import React from 'react'
import './ConfirmationInfo.css'

function ConfirmationInfoCES(props) {
  return (
    <>

          <tr>
            <td className='td-title-text'>
              <span className='title-text'>CES #: </span>
              <span className='info-text'>
                {props.confirmationData?.fileLotNumber}
              </span>
            </td>
          </tr>


          <tr>
            <td className='td-title-text'>
              <span className='title-text'>MBL: </span>
              <span className='info-text'>
                {props.confirmationData?.masterBillNumber}
              </span>
            </td>
          </tr>


    </>
  )
}

export default ConfirmationInfoCES
